__turbopack_context__.v({
  "blockLinkList": "BlockLinkList-module-scss-module__jPnFia__blockLinkList",
  "column": "BlockLinkList-module-scss-module__jPnFia__column",
  "cta": "BlockLinkList-module-scss-module__jPnFia__cta",
  "eyebrow": "BlockLinkList-module-scss-module__jPnFia__eyebrow",
  "flushTop": "BlockLinkList-module-scss-module__jPnFia__flushTop",
  "inner": "BlockLinkList-module-scss-module__jPnFia__inner",
  "linkText": "BlockLinkList-module-scss-module__jPnFia__linkText",
  "links": "BlockLinkList-module-scss-module__jPnFia__links",
});
